import CoreuiController from "../lib/coreui-controller"
import DatePicker from "../coreui/date-picker"

export default class CoreuiDatePickerController extends CoreuiController {
  static Component = DatePicker
}
